import * as TP from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateUserReferenceTypesMutationVariables = TP.Exact<{
  input: TP.UserReferenceTypeInput;
}>;


export type UpdateUserReferenceTypesMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly updateUserReferenceTypes: (
    { readonly __typename?: 'UserReferenceTypeResponse' }
    & Pick<TP.UserReferenceTypeResponse, 'modalId' | 'updatedAt'>
    & { readonly referenceTypes: ReadonlyArray<(
      { readonly __typename?: 'ReferenceTypeObject' }
      & Pick<TP.ReferenceTypeObject, 'id' | 'label' | 'referenceType'>
    )> }
  ) }
);


export const UpdateUserReferenceTypesDocument = gql`
    mutation UpdateUserReferenceTypes($input: UserReferenceTypeInput!) {
  updateUserReferenceTypes(input: $input) {
    modalId
    updatedAt
    referenceTypes {
      id
      label
      referenceType
    }
  }
}
    `;
export type UpdateUserReferenceTypesMutationFn = Apollo.MutationFunction<UpdateUserReferenceTypesMutation, UpdateUserReferenceTypesMutationVariables>;

/**
 * __useUpdateUserReferenceTypesMutation__
 *
 * To run a mutation, you first call `useUpdateUserReferenceTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserReferenceTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserReferenceTypesMutation, { data, loading, error }] = useUpdateUserReferenceTypesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserReferenceTypesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserReferenceTypesMutation, UpdateUserReferenceTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserReferenceTypesMutation, UpdateUserReferenceTypesMutationVariables>(UpdateUserReferenceTypesDocument, options);
      }
export type UpdateUserReferenceTypesMutationHookResult = ReturnType<typeof useUpdateUserReferenceTypesMutation>;
export type UpdateUserReferenceTypesMutationResult = Apollo.MutationResult<UpdateUserReferenceTypesMutation>;
export type UpdateUserReferenceTypesMutationOptions = Apollo.BaseMutationOptions<UpdateUserReferenceTypesMutation, UpdateUserReferenceTypesMutationVariables>;
/** Cypress helper for mocking the UpdateUserReferenceTypes mutation */
export const mockUpdateUserReferenceTypes = (
  response: MockResponse<UpdateUserReferenceTypesMutation>,
  kwargs?: Cypress.GqlKwargs
): void => cy.gql<UpdateUserReferenceTypesMutation>('UpdateUserReferenceTypes', response as anyOk, kwargs);